export class Scene3StepsExecutor {
  constructor({ video1, video2, timeScale = 1 } = {}) {
    this.video1 = video1;
    this.video2 = video2;
    this.timeScale = Number(timeScale) || 1;
  }

  async playVideos(config) {
    // Используем переданные в конструктор ссылки, либо ищем по ID как запасной вариант
    const v1 = this.video1 || document.getElementById('video1');
    const v2 = this.video2 || document.getElementById('video2');
    
    if (!v1 || !v2) {
        console.error("Видео-элементы не найдены! Проверьте ID в HTML или передачу в конструктор.");
        return;
    }

    v1.src = config.url1;
    v2.src = config.url2;      
    
    // УСТАНОВКА СКОРОСТИ
    v1.playbackRate = this.timeScale;
    v2.playbackRate = this.timeScale;

    const controls = document.getElementById('video-controls');
    if (controls && config.hideControls) controls.style.display = 'none';
    
    await Promise.all([v1.play(), v2.play()]);
    await new Promise(r => v1.onended = r);
  }

  async playAudio(url) {
    if (!url) return;
    const audio = new Audio(url);
    audio.volume = 1;
    audio.playbackRate = this.timeScale;

    try {
      await audio.play();
    } catch {
      // ignore
    }

    await new Promise((resolve) => {
      const done = () => resolve();
      audio.addEventListener('ended', done, { once: true });
      audio.addEventListener('error', done, { once: true });
    });
  }

  async waitForMs(ms) {
    const t = Number(ms) || 0;
    if (t <= 0) return;
    await new Promise((r) => setTimeout(r, t));
  }

  async waitForEnded(videoEl) {
    if (!videoEl) return;
    await new Promise((resolve) => {
      const done = () => resolve();
      videoEl.addEventListener('ended', done, { once: true });
      videoEl.addEventListener('error', done, { once: true });
    });
  }
}

